import { Component, input, OnDestroy, output } from "@angular/core";
import { debounce } from "lodash";

@Component({
  selector: "app-search-input",
  template: `
    <div class="search-input">
      <input
        type="text"
        [value]="searchTerm()"
        class="search-input__input"
        aria-label="Cherche des homophones"
        placeholder="Cherche des homophones"
        (input)="handleOnInput($event)"
        data-lpignore="true"
        [disabled]="isDisabled()"
      />

      @if (searchTerm() !== "") {
        <button type="button" class="search-input__clear-button" aria-label="Vider la barre de recherche" (click)="changeSearchTerm.emit('')">
          <img class="clear-button__icon" src="assets/icons/close.svg" alt="Vider la barre de recherche" />
          <span class="visuallyhidden">Vider la barre de recherche</span>
        </button>
      }
    </div>
  `,
  styles: `
    @use "typography" as *;
    @use "responsive" as *;

    .search-input {
      display: block;
      width: 100%;
      position: relative;
    }

    .search-input__input {
      display: block;
      width: 100%;
      padding: 12px 43px 12px 12px;
      @include body3();
      font-weight: 500;
      border-radius: 8px;
      background-color: #f5f3ef;
      border: none;

      &:focus {
        outline: none;
        box-shadow:
          0 0 0 2px #fff,
          0 0 0 6px #e7e1d8;
      }
    }

    .search-input__clear-button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 31px;
      height: 31px;
      position: absolute;
      z-index: 1000;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
      background: none;
      border: none;
      margin: 0;
      padding: 0;
      opacity: 0.5;

      &:focus {
        outline: none;
        opacity: 1;
      }

      &:hover {
        @include screenWidth("from-desktop") {
          transition: opacity 1s;
          opacity: 1;
        }
      }
    }

    .clear-button__icon {
      display: block;
      width: 100%;
      height: 100%;
    }
  `,
})
export class SearchInput implements OnDestroy {
  searchTerm = input.required<string>();

  isDisabled = input<boolean>(false);

  changeSearchTerm = output<string>();

  private updateSearchTerm = debounce((newSearchTerm: string) => {
    this.changeSearchTerm.emit(newSearchTerm);
  }, 500);

  protected handleOnInput(event: Event) {
    const target = event.target as HTMLInputElement;
    const newValue = target.value;
    this.updateSearchTerm(newValue);
  }

  ngOnDestroy() {
    this.updateSearchTerm.cancel();
  }
}
